import * as api from "../api/index";

import {
  ADD_NEW,
  UPDATE,
  DELETE,
  GET_INVOICE,
  FETCH_INVOICE_BY_USER,
  START_LOADING,
  END_LOADING,
  FILTER_INVOICE,
  FETCH_INVOICE_BY_PRODUCT,
  FETCH_PAYMENT,
  UPDATE_PAYMENT,
  FETCH_ALL,
} from "./constants";

// export const getInvoices = () => async (dispatch)=> {
//     try {
//         const { data } = await api.fetchInvoices()
//         dispatch({ type: FETCH_ALL, payload: data })
//     } catch (error) {
//         console.log(error)
//     }
// }

export const filterInvoices =
  ({ from, to, search }) =>
  async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const {
        data: { data },
      } = await api.fetchInvoicesByUser({ search });
      dispatch({ type: FILTER_INVOICE, payload: { from, to, data } });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.log(error.response);
    }
  };

export const getInvoicesByUser =
  ({ search, role, page, limit }) =>
  async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.fetchInvoicesByUser({
        search,
        role,
        page,
        limit,
      });
      console.log(data);
      dispatch({
        type: FETCH_INVOICE_BY_USER,
        payload: { data: data.invoices, role, totalPages: data.totalPages },
      });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.log(error);
    }
  };
export const getInvoicesByClient = (id) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchInvoicesByClient(id);

    dispatch({
      type: FETCH_INVOICE_BY_USER,
      payload: { data: data.invoices },
    });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};
export const getInvoicesByProduct =
  (searchQuery, itemId) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const {
        data: { data },
      } = await api.fetchInvoicesByProduct(searchQuery, itemId);
      dispatch({ type: FETCH_INVOICE_BY_PRODUCT, payload: data });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.log(error.response);
    }
  };

export const getInvoice = (id) => async (dispatch) => {
  const user = JSON.parse(localStorage.getItem("profile"));

  try {
    const { data } = await api.fetchInvoice(id);
    const businessDetails =
      user?.result?.role === "assistant"
        ? await api.fetchProfilesByUser({
            search: user?.result?.userId[0],
          })
        : await api.fetchProfilesByUser({
            search: user?.result?._id || user?.result?.googleId,
          });
    const invoiceData = { ...data, businessDetails };

    dispatch({ type: GET_INVOICE, payload: invoiceData });
  } catch (error) {
    console.log(error.response);
  }
};

export const createInvoice = (invoice, history) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.addInvoice(invoice);
    dispatch({ type: ADD_NEW, payload: data });
    history.push(`/invoice/${data._id}`);
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};
export const addPayment = (payment) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const data = await api.createPayment(payment);

    dispatch({ type: END_LOADING });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const updateInvoice = (id, invoice) => async (dispatch) => {
  try {
    const { data } = await api.updateInvoice(id, invoice);
    dispatch({ type: UPDATE, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const deleteInvoice = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteInvoice(id);

    dispatch({ type: DELETE, payload: id });
    openSnackbar("Invoice deleted successfully");
  } catch (error) {
    console.log(error.response);
  }
};

export const getPaymentAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.getPayment(id);
    dispatch({ type: FETCH_PAYMENT, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};
export const updatePaymentAction = (payment, id) => async (dispatch) => {
  try {
    const { data } = await api.updatePayment(payment, id);
    dispatch({ type: UPDATE_PAYMENT, payload: data });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchPartialAndNoPaidInvoicesAction =
  (id, query) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });

      const response = await api.fetchPartialAndNoPaidInvoices(id, query);
      console.log(response);
      dispatch({ type: FETCH_ALL, payload: response });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.log(error);
      console.log(error.response);
    }
  };
